import * as Init from '../init.js';
import { CLAPI } from '../clchart/cl.api.js'
import * as DATAS from '../datas/transdata.js'
import * as SIGNAL from './signal.res.js'

function getMclassName() {
    let mclassindex = DATAS.getArrayIndex(Init.getUserInfo('Signal', 'mclassindex', 0), SIGNAL.MCLASSS.length)
    return SIGNAL.MCLASSS[mclassindex]
}

function setMclassCtrl(curChart, inData, region) {
    const chartName = 'mclassCtrl'
    const chart = curChart.getChart(chartName)

    const curRect = CLAPI.getChartRect(region)
    const curCfg = {
        layout: {
            title: {
                pixel: 12, // 字体大小
                height: 18, // 最大高度
                spaceX: 10, // X方向留空
                spaceY: 2, // Y方向留空
            }
        },
        config: SIGNAL.CHART_SIGNAL_MCLASS,
        rectMain: curRect

    }
    let mclassindex = DATAS.getArrayIndex(Init.getUserInfo('Signal', 'mclassindex', 0), SIGNAL.MCLASSS.length)
    curCfg.config.selectIndex = mclassindex;
    
    chart.createChart(chartName, 'system.ctrls', curCfg, function (result) {
        // 这里应该返回交互信息 比如按钮按下 光标位置等
        if (result.event === 'btndown') {
            // console.log(chartName, result)
            Init.setUserInfo('Signal', 'mclassindex', result.selectIndex)
            onLoad()
        }
    })
}

function setDateCtrl(curChart, inData, region) {
    const chartName = 'DateCtrl'
    const chart = curChart.getChart(chartName)

    const curRect = CLAPI.getChartRect(region)
    const curCfg = {
        layout: {
            offset: { // 图形的偏移位置（不包括标题等），margin为整个图形区，offset仅仅是图形
                left: 1,
                top: 0,
                right: 0,
                bottom: 1,
            },
            title: {
                pixel: 12, // 字体大小
                height: 18, // 最大高度
                spaceX: 10, // X方向留空
                spaceY: 4, // Y方向留空
            }
        },
        config: SIGNAL.CHART_SIGNAL_DATES,
        rectMain: curRect

    }
    
    SIGNAL.setDatesTitle('日期列表')

    const mclassname = getMclassName()

    SIGNAL.clearDates()

    for (let index = inData['dates'].datas.length - 1; index >= 0; index--) {
        const msec = CLAPI.getData(inData['dates'], 'msec', index)
        SIGNAL.incrDates(CLAPI.Utils.getMsecDate(msec).toString(), 0.0)
    }
    curCfg.config.selectIndex = Init.getUserInfo('Signal', mclassname + 'dateindex', 0)
    // console.log(leftLayoutCfg.config.selectIndex);
    // const leftchart = 
    chart.createChart(chartName, 'system.ctrls', curCfg, function (result) {
        // 这里应该返回交互信息 比如按钮按下 光标位置等
        if (result.event === 'btndown') {
            // console.log(chartName, result)
            Init.setUserInfo('Signal', mclassname + 'dateindex', result.selectIndex)
            if (inData.newDate > 0 && 
                (curCfg.config.selectIndex === 0 && result.selectIndex !== 0) ||
                (curCfg.config.selectIndex !== 0 && result.selectIndex === 0)) {
                onLoadData(inData, true)
            }
            else {
                onLoadData(inData, false)
            }
        }
    })
}

function setSignalChart(curChart, inData, region) {
    const chartName = 'SignalChart'
    const chart = curChart.getChart(chartName)        
    {
        const cvname = chartName + 'market'
        const curRect = CLAPI.getChartRect(region, 1, 1, 0, 0)
        
        const curCfg = {
            layout: {
                offset: {
                    top: 5,
                    bottom: 5,
                    left: 5,
                    right: 5
                }, 
            },
            config: CLAPI.Utils.mergeObjectOfDeep(
                {
                    header : {
                        spaceY: 4, // Y方向留空     
                    },
                    fieldlock  : 3,  // 按左键时，前面3个字段不动        
                    curKeyIdx  : 1,  // 用于检索curKey的字段索引
                }, CLAPI.ChartRes.CHART_TABLE),
            tableInfo : SIGNAL.signalInfo,
            rectMain: curRect
        }
        const mclassname = getMclassName()
        const curIndex = Init.getUserInfo('Signal', mclassname + 'dateindex', 0)
        if (curIndex === 0 && inData.newDate > 0) {
            curCfg.tableInfo = SIGNAL.signalNowInfo
        }
        const curchart = chart.createChart(cvname, 'system.table', curCfg, function (result) {
            // 这里应该返回交互信息 比如按钮按下 光标位置等
            // if (result.event === 'headclick') {
            //     console.log(result);
            // }
            if (result.event === 'changeselect') {
                Init.setcurKey(result.curCode)
                chart.setlinkInfo('curKey', result.curCode)
            }
            if (result.event === 'dataclick') {
                // console.log(result, makets);
                result.key = 'Enter'
                result.code = 'Enter'
                result.keyCode = 13
                Init.setcurKey(result.curCode)
                chart.setlinkInfo('curKey', result.curCode)
                Init.sendKeydownEvent(result)
            }
        })
        chart.setlinkInfo('curKey', Init.getcurKey())
        chart.bindData(curchart, cvname)
    }

}

function readySignal(curChart, inData) {
    const chartName = 'SignalChart'
    const chart = curChart.getChart(chartName)
    
    // 这里设置公共信息
    inData['KeyInfo'] = DATAS.mAinfoToKeyInfo(inData['ainfos'])
    chart.setKeyInfo(inData['KeyInfo'])
    
    {
        const keyInfo = chart.getKeyInfo()
        const cvname = chartName + 'market'
        const vdatas = SIGNAL.GetAsignalTable(inData['asignal'], keyInfo, inData.newpInfo)
        
        // console.log(vdatas);
        
        let sumrate = 0.0
        for (let index = 0; index < vdatas.datas.length; index++) {
            sumrate += CLAPI.getData(vdatas, 'rate', index)
            // console.log(sumrate);          
        }
        sumrate /= vdatas.datas.length
        SIGNAL.setDatesValue(inData.curDate, sumrate)
        
        chart.setData(cvname, vdatas)
    }

}

// 画日线
function drawSignal(inData, isFirst) {

    console.log('Draw ====> Market Table')
    console.log(inData)
    
    const curChart = Init.getSysChart()
    if (isFirst) {
        // 设置为单一窗口 并返回第一个窗口
        curChart.initChart(['SignalChart', 'mclassCtrl', 'DateCtrl'])
        // 得到第一个窗口
        const canvas = Init.canvas
        
        const ctrlWidth = SIGNAL.FWIDTH * Init.scale
        const clsHeight = 25 * Init.scale
        // 设置顶部窗口
        setMclassCtrl(curChart, inData, {
            style: 'sidebar',
            top: 0,
            left: 0,
            width: canvas.width,
            height: clsHeight,
        })
        // 设置左部窗口
        setDateCtrl(curChart, inData, {
            style: 'sidebar',
            top: clsHeight,
            left: 0,
            width: ctrlWidth - Init.scale,
            height: canvas.height - clsHeight,
        })

        setSignalChart(curChart, inData, {
            style: 'average',
            top: clsHeight,
            left: ctrlWidth,
            width: canvas.width - ctrlWidth,
            height: canvas.height - clsHeight,
        })
    }

    readySignal(curChart, inData)
    
    curChart.onPaint()
}

function getDateIndex(inData, mclassname){
    let curIndex = Init.getUserInfo('Signal', mclassname + 'dateindex', 0)
    if (curIndex < inData['dates'].datas.length && curIndex >= 0) {
        curIndex = inData['dates'].datas.length - curIndex - 1 
    }
    else {
        curIndex = inData['dates'].datas.length - 1 
    }
    return curIndex
}
function onLoadData(inData, isFirst) {

    const mclassname = getMclassName()
    
    const curIndex = getDateIndex(inData, mclassname)
    // console.log(curIndex, Init.getUserInfo('Signal', mclassname + 'dateindex', 0), inData['dates'].datas.length);
    
    const curDate = CLAPI.Utils.getMsecDate(inData['dates'].datas[curIndex][0]);
    inData.curDate = curDate;
    // console.log(inData.newDate, curDate);
    
    if (inData.curDate < inData.newDate || inData.newDate == 0) {
        Init.sendCommand(
            {   
                cmds : {
                    "asignal" : { "cmd" : "get", "subject" : "CN000000.db_ssumm", "service": "signal/" + mclassname, "info" : {"sub-date" : curDate}}
                }
            },
            
            function reply(datas) {
                if (Init.checkDatas(datas)) {
                    inData['asignal'] = datas['asignal']
                    drawSignal(inData, isFirst)
                }
            });
    }
    else {
        // 从 nsignal --> asignal
        console.log(inData['nsignal']);
        
        inData['asignal'] = SIGNAL.transAsignal(inData['nsignal'], inData.newpInfo)
        drawSignal(inData, isFirst)
    }
}

export function onLoad() {
    SIGNAL.onInit()
    // 再获取
    function makeNsignal(inData)
    {
        let nowDate = 0
        let nowMsec = 0
        let nowInfo
        if (inData['nsignal']) {
            if (inData['nsignal']['infos'] && inData['nsignal']['infos'].length > 0) {
                nowInfo = inData['nsignal']['infos'][0];
                nowMsec = CLAPI.Utils.strMsecToMTime(nowInfo.msecstamp)
            }  
        }
        // console.log(nowInfo, nowMsec);
        if (nowMsec > 0) {
            nowDate = CLAPI.Utils.getMsecDate(nowMsec)
            if (nowDate > 0) {
                // 增加索引
                inData['dates'].datas.push([nowMsec])
            }
        }
        return nowDate
    }
    function onLoadInitInfo(inData) 
    {
        const nowDate = CLAPI.Utils.getNowDate()
        const curDate = CLAPI.Utils.getMsecDate(inData['dates'].datas[inData['dates'].datas.length - 1][0]);
        const mclassname = getMclassName()
        
        Init.sendCommand(
        {   
            cmds : {
                "ainfos"  : { "cmd" : "get", "subject" : "CN000000.alpha_info", "service": "atdb/minu1", "info" : { "sub-date" : curDate}},
                "ninfos"  : { "cmd" : "get", "subject" : "CN000000.alpha_stopinfo", "service": "atdb/minu1", "info" : { "sub-date" : curDate, "fields" : 'msec,code,newprc'}},
                "nsignal" : { "cmd" : "redis", "subject" : "signal", "service": '47.242.109.110:17329', "info" : {"command" : "lrange " + mclassname + ":" + nowDate + " 0 -1"}},
            }
        },
        function reply(datas) {
            if (Init.checkDatas(datas, ['nsignal'])) {
                datas['dates']   = CLAPI.Utils.copyObjectOfDeep(inData['dates'])
                // datas['nsignal'] = CLAPI.Utils.copyObjectOfDeep(datas['nsignal'])
                // datas['ainfos']  = datas['ainfos']
                // datas['ninfos']  = datas['ninfos']
                // 下面设置当前的公共信息
                datas.newpInfo = SIGNAL.InfoSetNewp(datas['ninfos'], datas.newpInfo, datas['ainfos'])
                datas.newDate = makeNsignal(datas)
                // console.log(datas.newDate);
                
                onLoadData(datas, true)
            }
        });
    }
    Init.sendCommand(
        {   
            cmds : {
                "dates"   : { "cmd" : "get", "subject" : "SH000001.alpha_info", "service": "merge/ainfo", "info" : {"offset" : -60, "fields" : 'msec'}}
            }
        },
        function reply(datas) {
            console.log(datas)
            if (Init.checkDatas(datas)) {
                onLoadInitInfo(datas)
            }
        });
}


// 注册方法到参数表
